import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'

export default class UserService {
    constructor(passwordCrypter) {
        this.passwordCrypter = passwordCrypter
        this.apis = {
            getAll: () => axios.get(APIConfig.APIURL + '/user'),
            add: (payload) => axios.post(APIConfig.APIURL + '/user', payload),
            edit: (id, payload) => axios.put(APIConfig.APIURL + `/user/${id}`, payload),
            inActivate: (id) => axios.post(APIConfig.APIURL + `/user/${id}/inactivate`),
            // delete: (id) => axios.delete(APIConfig.APIURL + `/user/${id}`),

            // user only
            updateMe: (payload) => axios.put(APIConfig.APIURL + '/me/profile', payload),
            updatePassword: (payload) => axios.put(APIConfig.APIURL + '/me/password', payload),
            // admin
            resetPassword: (id) => axios.post(APIConfig.APIURL + `/user/${id}/password/reset`)
        }
    }

    prepareData(vm) {
        return new Promise((resolve, reject) => {
            if (vm.$store.state.user.isFetched) {
                resolve(vm.$store.state.user.list)
                return
            }
            if (vm.$store.state.user.isFetching) {
                var timer = setInterval(() => {
                    if (vm.$store.state.user.isFetching) return
                    clearInterval(timer)
                    if (vm.$store.state.user.isFetched) {
                        resolve(vm.$store.state.user.list)
                    } else {
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            return this.getAll(vm)
                .then(res => {
                    vm.$store.state.user.isFetched = true
                    vm.$store.state.user.list = res.data.result || []
                    return res
                })
                .then(res => {
                    vm.$store.state.user.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    vm.$store.state.user.isFetching = false
                    reject(err)
                })
        })
    }

    getAll(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getAll()
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.User.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    updateMe(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.updateMe(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {

                        let jwt = vm.$services.auth.getJWT();
                        if (!jwt) {
                            reject('API更新成功，網頁資料異常，請重新整理')
                            return
                        }
                        var meIndex =
                            vm.$store.state.user.list.findIndex(
                                o => o.ID === JSON.parse(atob(jwt.split(".")[1])).ID
                            )

                        vm.$set(vm.$store.state.user.list[meIndex].Profile, 'Name', payload.Name)
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    updatePassword(vm, params) {
        let payload = {
            'old': this.passwordCrypter.cryptPassword(params.old),
            'new': this.passwordCrypter.cryptPassword(params.new)
        }
        return new Promise((resolve, reject) => {
            this.apis.updatePassword(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    resetPassword(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.resetPassword(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
